module.exports = __webpack_public_path__ + "img/thicon.c8d7cf72.png";